export const protocolColumns = (t) => [
  { field: "protocolId", header: t("PROTOCOLS.COLUMNS.PROTOCOL_ID") },
  { field: "platformName", header: t("PROTOCOLS.COLUMNS.PLATFORM") },
  { field: "clientName", header: t("PROTOCOLS.COLUMNS.CLIENT") },
  { field: "regionalName", header: t("PROTOCOLS.COLUMNS.REGIONAL") },
  { field: "licensePlate", header: t("PROTOCOLS.COLUMNS.PLATE") },
  { field: "protocolType", header: t("PROTOCOLS.COLUMNS.TYPE") },
  { field: "protocolSubtype", header: t("PROTOCOLS.COLUMNS.SUBTYPE") },
  { field: "protocolStatus", header: t("PROTOCOLS.COLUMNS.STATUS") },
  { field: "eventDate", header: t("PROTOCOLS.COLUMNS.EVENT_DATE") },
  { field: "lastUpdate", header: t("PROTOCOLS.COLUMNS.LAST_UPDATE") },
];
